// The one order a list's rows are in, which both builds must agree on.
//
// Pure, like everything under shared/: no clock, locale, randomness, crypto or
// BigInt. Nothing here makes an order key.

export interface Ordered {
  readonly id: string;
  readonly orderKey: string;
}

/**
 * Key first, then id, both by UTF-16 code unit. Keys are base-62 ASCII, so
 * this is also SQLite's BINARY collation. The id only decides between two
 * rows that share a key, which nothing should produce, but an order that
 * depended on Map insertion would disagree across devices.
 */
export function compareOrder(a: Ordered, b: Ordered): number {
  if (a.orderKey !== b.orderKey) return a.orderKey < b.orderKey ? -1 : 1;
  if (a.id !== b.id) return a.id < b.id ? -1 : 1;
  return 0;
}
